import classNames from "classnames";
import PropTypes from "prop-types";
import React, { useEffect, useState, useRef } from "react";
import { scrollToErrorElement } from "../../utils/dom";
import BodyText from "../body-text";
import "./style.scss";

const Checkbox = ({ id, label, checked = false, error = false, disabled = false, infoText, className, preventScroll = false, onChange }) => {
  const checkboxElement = useRef(null);
  const [isChecked, setIsChecked] = useState(checked);

  useEffect(() => {
    setIsChecked(checked);
  }, [checked, setIsChecked]);

  useEffect(() => {
    !preventScroll && scrollToErrorElement(checkboxElement.current);
  }, [error]);

  const handleOnChange = evt => {
    if (!disabled) {
      if (evt.target.nodeName === "A") {
        return;
      }
      setIsChecked(!isChecked);
      onChange(!isChecked, { id: id, label: label });
    }
  };
  const selectWithKeyboardKeys = event => {
    const SPACE = 32;
    const ENTER = 13;

    if (event.keyCode === SPACE || event.keyCode === ENTER) {
      event.preventDefault();
      handleOnChange(event);
    }
  };

  const checkboxClassNames = classNames("checkbox", className, {
    error: error && !isChecked,
    disabled
  });

  const IconContainerClasses = classNames("icon-container", {
    checked: isChecked,
    error: error && !isChecked
  });

  return (
    <>
      <div ref={checkboxElement} className={checkboxClassNames} onClick={evt => handleOnChange(evt)} onKeyDown={event => selectWithKeyboardKeys(event)} tabIndex="0">
        <div className="checkbox__content" tabIndex="-1">
          <div className={IconContainerClasses}>
            {isChecked && (
              <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                <path d="M0 0h24v24H0V0z" fill="none" />
                <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
              </svg>
            )}
          </div>

          {label && <BodyText tagName={"p"} className="label" html={label} />}
        </div>
      </div>
      {infoText && infoText.value && (
        <div>
          <BodyText className="info-text" html={infoText} />
        </div>
      )}
    </>
  );
};

Checkbox.propTypes = {
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  error: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  infoText: PropTypes.string,
  disabled: PropTypes.bool
};

Checkbox.defaultProps = {
  checked: false,
  error: false,
  disabled: false
};

export default Checkbox;
